"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactTruncate = _interopRequireDefault(require("react-truncate"));

var _Tooltip = _interopRequireDefault(require("react-bootstrap/lib/Tooltip"));

var _OverlayTrigger = _interopRequireDefault(require("react-bootstrap/lib/OverlayTrigger"));

var _prefix = _interopRequireDefault(require("../prefix"));
/** A way to shorten text by omitting some of it */


var TruncateText = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TruncateText, _Component);

  function TruncateText() {
    var _this;

    (0, _classCallCheck2["default"])(this, TruncateText);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(TruncateText).call(this));

    _this.toggleLines = function (event) {
      event.preventDefault();

      _this.setState(function (prevState) {
        return {
          expanded: !prevState.expanded
        };
      });
    };

    _this.state = {
      expanded: false
    };
    return _this;
  }

  (0, _createClass2["default"])(TruncateText, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          htmlId = _this$props.htmlId,
          lines = _this$props.lines,
          displayToolTip = _this$props.displayToolTip,
          ellipsis = _this$props.ellipsis,
          expandAnchorText = _this$props.expandAnchorText,
          collapseAnchorText = _this$props.collapseAnchorText,
          displayTruncatedText = _this$props.displayTruncatedText;
      var styles = {
        display: "block",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden"
      };

      if (!lines && displayToolTip) {
        return /*#__PURE__*/_react["default"].createElement(_OverlayTrigger["default"], {
          trigger: ["hover", "click"],
          placement: "top",
          overlay: /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
            id: "".concat(htmlId, "-Tooltip"),
            bsClass: "".concat(_prefix["default"], "tooltip")
          }, children)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: htmlId,
          className: "truncate-singleline",
          style: styles
        }, children));
      } else if (!lines) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: htmlId,
          className: "truncate-singleline",
          style: styles
        }, children);
      } else {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactTruncate["default"], {
          lines: displayTruncatedText ? !this.state.expanded && lines : lines,
          ellipsis: displayTruncatedText ? /*#__PURE__*/_react["default"].createElement("a", {
            href: "#expand",
            onClick: this.toggleLines
          }, " ", expandAnchorText, " ") : ellipsis
        }, children), this.state.expanded && /*#__PURE__*/_react["default"].createElement("span", null, " ", /*#__PURE__*/_react["default"].createElement("a", {
          href: "#expand",
          onClick: this.toggleLines
        }, " ", collapseAnchorText, " ")));
      }
    }
  }]);
  return TruncateText;
}(_react.Component);

TruncateText.defaultProps = {
  displayToolTip: false,
  expandAnchorText: "Show more",
  collapseAnchorText: "Show less"
};
var _default = TruncateText;
exports["default"] = _default;